/** @jsx jsx */
import { jsx, Button, Flex } from 'theme-ui'
import { bool, node, oneOf } from 'prop-types'
import { flatButtonStyles } from './Styled'

const FlatButton = ({
  buttonStyle,
  children,
  color,
  leftIcon,
  rightIcon,
  size = 'small',
  disabled,
  ...props
}) => {
  const getStyle = style => flatButtonStyles[color][style]
  return (
    <Button
      disabled={disabled}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 30,
        color: disabled ? getStyle('colorDisabled') : getStyle('color'),
        fontSize: size === 'small' ? 0 : 4,
        fontWeight: size === 'small' ? 'semiBold' : 'normal',
        textTransform: size === 'small' ? 'uppercase' : 'none',
        '&:hover': {
          borderBottomColor: disabled
            ? getStyle('colorDisabled')
            : getStyle('borderColorHover'),
          borderBottomStyle: !disabled && 'solid',
          borderBottomWidth: '2px',
          color: disabled ? getStyle('colorDisabled') : getStyle('color'),
          cursor: disabled ? 'default' : 'pointer',
        },
      }}
      variant={buttonStyle}
      {...props}
    >
      {leftIcon && <Flex sx={{ pr: 1 }}>{leftIcon}</Flex>}
      {children}
      {rightIcon && <Flex sx={{ pl: 1 }}>{rightIcon}</Flex>}
    </Button>
  )
}
FlatButton.propTypes = {
  buttonStyle: oneOf(['tertiary']),
  children: node,
  color: oneOf(['forest', 'skyLight', 'skyDark', 'citron']),
  disabled: bool,
  leftIcon: node,
  rightIcon: node,
  size: oneOf(['small', 'large']),
}

export default FlatButton
